import Vue from "vue";
import VueRouter from "vue-router";
import authRoutes from "@/_auth/authRoutes";
import UserRoutes from './app_routes/UserRoutes'
import CompanyRoutes from './app_routes/CompanyRoutes'
import CompanySettingsRoutes from './app_routes/CompanySettingsRoutes'
import Members from './app_routes/MemberRoutes'
import Financial from './app_routes/FinancialRoutes'
import Event from './app_routes/EventRoutes'
import StatisticsRoutes from './app_routes/StatisticsRoutes'
import NegotiationRoutes from './app_routes/NegotiationRoutes'
import SuperAdminControlRoutes from './app_routes/SuperAdminControlRoutes'



Vue.use(VueRouter);

const routes = [
  ...authRoutes,
  ...CompanySettingsRoutes,
  ...CompanyRoutes,
  ...UserRoutes,
  ...Members,
  ...Financial,
  ...Event,
  ...StatisticsRoutes,
  ...NegotiationRoutes,
  ...SuperAdminControlRoutes,
  {
    path: "/",
    name: "Home",
    component: () => import("../pages/Home.vue"),
    meta: {
      auth: true,
      needs_company: true,
    }
  },
  {
    path: "/profile",
    name: "Account",
    component: () => import("../pages/Account.vue"),
    meta: {
      auth: true
    }
  },
  {
    path: '*',
    name: 'Err404',
    component: () => import('@/pages/Err404.vue'),
  },
];

Vue.router = new VueRouter({
  mode: "history",
  base: process.env.BASE_URL,
  routes
});

Vue.router.beforeEach(async(to, from, next) => {
  document.title = '4artz'
  const local = localStorage.getItem('has_companies')
  
  if (!Number(local) && to.meta && to.meta.needs_company){
    next({ name: 'Account' })
  } else {
    next()
  }
})

export default Vue.router;
